/* eslint-disable import/no-anonymous-default-export */
export default (approved = [], action) => {
  switch (action.type) {
    case "GET_ALL_APPROVED_CLAIMS":
      return action.payload;
    case "PRINT_BRANCH_CLAIM":
      return approved.filter((data) => data._id !== action.payload);

    default:
      return approved;
  }
};
